/*
=========================================================================================
	File Name: moduleAuthMutations.js
	Description: Auth Module Mutations
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================
*/

import axios from '../../http/axios/index.js'

export default {
	STOCKTRACKING_TYPE_LIST(state, value) {
		state.StocktrackingType = value;
	}, ADD_ITEM_STOCKTRACKING(state, item) {
		const output = Object.entries(item).map(([key, value]) => [
			key[0].toUpperCase() + key.slice(1), value,]);
		state.StockTracking.push(Object.assign({}, Object.fromEntries(output)))
	},
	DELETE_ITEM_STOCKTRACKING(state, item) {
		const index = state.StockTracking.findIndex(i => i.StockTrackingId === item)
		if (index > -1) { state.StockTracking.splice(index, 1) }
	}, STOCKTRACKING_LIST(state, value) {
		state.StockTracking = value;
	}, STOCKTRACKING_DETAILS_LIST(state, value) {
		state.StockTrackingDetails = value
	}
}
